import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const NONE = { create: false, edit: false, approve: false, cancel: false, delete: false, send: false };

export function useSalesCapabilities() {
  const [caps, setCaps] = useState(NONE);
  useEffect(() => { api.get("/sales-orders-capabilities").then(setCaps).catch(() => setCaps(NONE)); }, []);
  return caps;
}
